export const cart = {
  cartDetails: {
    id: 'ID',
    proceedToCheckout: 'Zur Kasse',
    cartName: 'Warenkorb #{{code}}',
    itemsNotReserved: 'Artikel im Warenkorb werden nicht reserviert.',
    article: 'Artikel',
  },
  cartItems: {
    id: 'ID',
    description: 'Beschreibung',
    item: 'Artikel',
    itemPrice: 'Artikel Preis',
    quantity: 'Menge',
    quantityTitle: 'Die Menge gibt die Gesamtzahl des Artikels in Ihrem Warenkorb an.',
    total: 'Gesamt',
    cartTotal: 'Dein Warenkorb ({{count}})',
    cartTotal_plural: 'Dein Warenkorb ({{count}})',
    speditionArticle: 'Speditionsartikel',
    itemAddedToCart: 'Dein Artikel wurde zum Warenkorb hinzugefügt',
    personalisation: 'Personalisierung',
    personalised: 'personalisiert',
    fontStyle: 'Schriftart',
    yourInput: 'Deine Angaben',
    removeFromCart: 'Entfernen',
    itemCounterMinRestrition: 'Die Mindestanzahl an Artikeln für ein Produkt beträgt 1.',
    itemCounterMaxRestrition: 'Die maximale Anzahl an Artikeln für dieses Produkt beträgt {{max}}.',
    soldOut: 'Bald wieder verfügbar',
    notifyMe: 'Benachrichtige mich',
    personalize: 'Personalisierbar',
  },
  orderCost: {
    orderSummary: 'Bestellübersicht',
    subtotal: 'Zwischensumme nach Preisnachlässen:',
    shipping: 'Versand:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'gespart:',
    salesTax: 'MwSt:',
    grossTax: 'Der Gesamtbetrag der Bestellung enthält folgenden Steuerbetrag nicht:',
    grossIncludeTax: 'Der Gesamtbetrag der Bestellung enthält Steuern in Höhe von',
    total: 'Gesamt:',
    toBeDetermined: 'wird noch bestimmt',
  },
  voucher: {
    coupon: 'Hast du einen Vorteilscode?',
    couponGiftcard: 'Hast du einen Gutschein oder Vorteilscode?',
    coupon_plural: 'Gutscheine oder Vorteilscodes',
    apply: 'Anwenden',
    placeholder: 'Promo code',
    applyVoucherSuccess: '{{voucherCode}} wurde hinterlegt.',
    applyGiftcardSuccess: 'Der Gutschein {{voucherCode}} wurde dem Warenkorb hinzugefügt.',
    removeVoucherSuccess: '{{voucherCode}} wurde entfernt.',
    anchorLabel: 'Gutschein/Vorteilscode eingeben oder entfernen.',
    vouchersApplied: 'Hinterlegte Gutscheine/Vorteilscodes',
    availableCoupons: 'Verfügbare Vorteilscodes',
    availableCouponsLabel: 'Du kannst diese Vorteilscodes hinzufügen.',
    promotionError: {
      ERR01: 'Die Aktion ist bereits beendet.',
      ERR02: 'Der Vorteilscode ist noch nicht gültig.',
      ERR03: 'Der Vorteilscode ist nicht gültig.',
      ERR05: 'Dein Warenkorb enthält kein Produkt, auf das die Aktion angewendet werden kann.',
      ERR06:
        'Der von dir angegebene Code wurde bereits eingelöst und kann nicht noch einmal verwendet werden.',
      ERR07: 'Der Mindestbestellwert für die Aktion ist nicht erreicht.',
      ERR08: 'Der Vorteilscode ist nicht gültig.',
      ERR09:
        'Aufgrund der Best-Preis-Logik können manche Aktionen nicht parallel eingelöst werden.',
      ERR10:
        'Der Versand ist kostenfrei, deshalb kann der von Dir angegebene Code kann nicht hinzugefügt werden.',
      ERR12: 'Der Gutschein wurde bereits eingelöst.',
      ERR13:
        'Leider können Vorteilscodes derzeit aus technischen Gründen nicht eingelöst werden. Bitte wenden Sie sich an unseren Kundenservice.',
      ERR14: 'Der Rabattcode kann auf deinen Warenkorb nicht angewendet werden.',
      ERR14WithDisclaimer:
        'Der Rabattcode kann auf deinen Warenkorb nicht angewendet werden. Bitte beachte die Aktionsbedingungen:<br>[Vorteilscode: {{voucherCode}}<br><br>{{disclaimer}}]',
    },
  },
  saveForLaterItems: {
    itemTotal: 'Für später gespeichert ({{count}} Artikel)',
    itemTotal_plural: 'Für später gespeichert ({{count}} Artikel)',
    cartTitle: 'Warenkorb',
    yourCart: 'Dein Warenkorb',
    saveForLater: 'Für später gespeichert',
    moveToCart: 'In den Warenkorb',
    stock: 'Lagerbestand',
    forceInStock: 'Auf Lager',
  },
};
